import { React, useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  RightLayoutContainer,
  PageTitleComp,
  TableLayoutData,
} from "../../styledElements";
import { Button, PageHeader, Table, Tooltip } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import { Styled } from "../../pageStyled";
import {
  getProductsDataForConfiguration,
  searchProducts,
  getFilteredProducts,
} from "../../../Services/productServices";
import moment from "moment";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import EmptyState from "../../../Components/EmptyState/emptyState";
import AddNewSize from "../../StockManagement/AddNewSize";
import {
  lengthUnit,
  weightUnit,
  currency_List

} from "../../../Utils/Constant/MeasurementUnitList.jsx";

const ProductsRecordsData = (props) => {
  const location = useLocation();
  const history = useNavigate();
  const [addToaster, setAddToaster] = useState(
    location.state?.action === "add"
  );
  const [deleteToaster, setDeleteToaster] = useState(
    location.state?.action === "delete"
  );
  const [productRecords, setProductRecords] = useState([]);
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [totalRecords, setTotalRecords] = useState();
  const [tableParams, setTableParams] = useState({
    sort_by: "created_at",
    sort_type: "descending",
    page: 1,
    size: 10,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [clearSearch, setClearSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [filterTags, setFilterTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const [rendering, setRendering] = useState(false);
  const [newStockSizeDrawer, setNewStockSizeDrawer] = useState(false);
  const [product, setProduct] = useState();
  const [selectedStockSize, setSelectedStockSize] = useState();
  const [stockSizesListRawData, setStockSizesListRawData] = useState([]);
  const [selectedStockSizeRow, setSelectedStockSizeRow] = useState();
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const paginationRef = useRef({
    sort_by: "created_at",
    sort_type: "descending",
    page: 1,
    size: 10,
  });
  const titleRef = useRef(null);
  const [stickyOffsets, setStickyOffsets] = useState({ title: 58, table: 100 });

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      const baseTop = 58;
      const titleHeight = titleRef.current?.offsetHeight || 0;

      setStickyOffsets({
        title: baseTop,
        table: baseTop + titleHeight
      });
    });

    if (titleRef.current) observer.observe(titleRef.current);

    return () => observer.disconnect();
  }, [rendering]);

  const columnsHead = useRef([
    {
      title: "Product code",
      dataIndex: "code",
      width: "13%",
      sorter: {
        compare: (a, b) => a.productcode - b.productcode,
      },
      align: "left",
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      width: "13%",
      sorter: {
        compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
      },
    },
    {
      title: "product name",
      dataIndex: "name",
      width: "19%",
    },
    {
      title: "grade",
      dataIndex: "grade",
      width: "14%",
    },
    {
      title: "GSM",
      dataIndex: "gsm",
      sorter: {
        compare: (a, b) => a.gsm - b.gsm,
      },
    },
    {
      title: "BF",
      dataIndex: "burst_factor",
      sorter: {
        compare: (a, b) => a.bf - b.bf,
      },
    },
    {
      title: "quality",
      dataIndex: "quality",
      width: "16%",
    },
    {
      title: "bulk(cc/gm)",
      dataIndex: "bulk",
    },
    {
      title: "Moisture",
      dataIndex: "moisture",
    },
    {
      title: "price",
      dataIndex: "price",
      width: "19%",
    },
    {
      title: "Stock",
      dataIndex: "is_stock_available",
      width: "5%",
      align: "center",
      render: (text, record) => {
        let tooltip = "";
        if (record.is_stock_available) {
          //tooltip = tooltip + "Available stock sizes are "
          for (let index = 0; index < record.stocks.length; index++) {
            const element = record.stocks[index];
            if (index < 10) {
              if (element.stocks_type === "reel") {
                tooltip = tooltip + element.width + " CM";
              } else {
                tooltip = tooltip + element.length + "*" + element.width + " CM";
              }
              if (index != record.stocks.length - 1) {
                tooltip = tooltip + ', '
              }
              if (index > 9) {
                break;
              }
            }

          }
          if (record.stocks.length > 10) {
            tooltip =
              `${tooltip} and ${record.stocks.length - 10} more sizes`;
          }
        } else {
          tooltip = "Stock sizes are not available  for this product";
        }
        return (
          <div className="actionBtn">
            <Tooltip
              placement="bottomRight"
              title={tooltip}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button style={{ cursor: "default" }}>
                <Iconmoon
                  icon={text ? "correct" : "wrong"}
                  size={16}
                  color={text ? "#3FBD61" : "#a19f9d"}
                />
              </Button>
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.status === "Active"
                  ? "This product is active."
                  : record.status === "Disabled"
                    ? "This product is disabled for accepting orders."
                    : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {" "}
              {record.status}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      render: (text, record) => (
        <div className="actionBtn">
          {userDetails.roles.product_records.edit && (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"Edit this product"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => handleEdit(record)}>
                  <Iconmoon icon="edit" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          )}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View details of this product"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button onClick={() => handleView(record)}>
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
          {userDetails.roles.product_records.edit && (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"Add stock size for this product"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => handleAddStock(record)}>
                  <Iconmoon icon="AddStock" size={19} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          )}
        </div>
      ),
      align: "center",
    },
  ]);

  useEffect(() => {
    setLoading(true);
    console.log("tableParams", tableParams, "rendering", rendering);

    if (rendering && !appliedFilters.length && searchValue == "") {
      fetchProductRecords(paginationRef.current);
      setRendering(false);
    } else if (!appliedFilters.length && searchValue == "") {
      fetchProductRecords(paginationRef.current);
    }
    else if (appliedFilters.length > 0) {
      fetchFilteredProducts();
      setRendering(false);
    }
    else if (!appliedFilters.length && searchValue !== "") {
      searchProducts(searchValue, paginationRef.current)
        .then((response) => {
          setLoading(false);
          setEmptyStateLabel("search");
          const formattedRecords = response.products?.map((product) => {
            return {
              code: product.code,
              created_at: moment(product.created_at).format("DD MMM YYYY"),
              name: product.name,
              grade: product.grade,
              gsm: product.gsm,
              burst_factor: product.burst_factor ? product.burst_factor : "-",
              quality: product.quality,
              bulk: product.bulk,
              price: (currency_List.find((data) => data.code == product.units.price)).symbol + ' ' + parseInt(product.price).toFixed(2) + ' ' + (" /" + weightUnit[product.units.per_weight_unit]?.displayName?.toUpperCase()),
              status: product.status === "active" ? "Active" : "Disabled",
              product_spec: product.product_spec,
              is_stock_available: product.is_stock_available,
              stocks: product.stocks,
              moisture: product.moisture ? product.moisture : "-",
            };
          });
          setProductRecords(formattedRecords);
          setTotalRecords(response.total_products);
        })
        .catch(
          (error) => console.log("Error in searching products:", error),
          setEmptyStateLabel("connectionAPIError")
        );
    }
  }, [tableParams, rendering, appliedFilters, searchValue]);

  // useEffect(() => {
  //   setLoading(true);
  //   if (appliedFilters.length) {
  //     fetchFilteredProducts();
  //   } else if (searchValue !== "") {
  //     searchProducts(searchValue, paginationRef.current)
  //       .then((response) => {
  //         setLoading(false);
  //         if (!response.products.length) {
  //           setEmptyStateLabel("noData");
  //         }
  //         const formattedRecords = response.products?.map((product) => {
  //           return {
  //             code: product.code,
  //             created_at: moment(product.created_at).format("DD MMM YYYY"),
  //             name: product.name,
  //             grade: product.grade,
  //             gsm: product.gsm,
  //             burst_factor: product.burst_factor ? product.burst_factor : "-",
  //             quality: product.quality,
  //             bulk: product.bulk,
  //             price: (currency_List.find((data) => data.code == product.units.price)).symbol + ' ' + parseInt(product.price).toFixed(2) + ' '+ (" /" + weightUnit[product.units.per_weight_unit]?.displayName?.toUpperCase()),
  //             status: product.status === "active" ? "Active" : "Disabled",
  //             product_spec: product.product_spec,
  //             is_stock_available: product.is_stock_available,
  //             stocks: product.stocks,
  //             moisture : product.moisture ? product.moisture : "-",
  //           };
  //         });
  //         setProductRecords(formattedRecords);
  //         setTotalRecords(response.total_products);
  //       })
  //       .catch((error) => {
  //         console.log("Error in searching products:", error);
  //       });
  //   } else {
  //     fetchProductRecords(paginationRef.current);
  //   }
  // }, [appliedFilters, tableParams]);

  useEffect(() => {
    let propsData = {};
    if (emptyStateLabel === "noData") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records in this list";
      propsData["subHeading"] =
        "There are no records to show in this list. Add your first record to view details here";
    } else if (emptyStateLabel === "search") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] =
        "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
    } else if (emptyStateLabel === "filter") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] =
        "There is no record matching your filter. Try changing your filter to find what you are looking for.";
    } else {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "Something went wrong";
      propsData["subHeading"] =
        "Check your internet connection or try reloading the page.";
    }
    setEmptyStatePropsData(propsData);
  }, [emptyStateLabel]);

  const refresh = () => {
    setLoading(true);
    setProductRecords();
    setSearchValue("");
    setClearSearch(true);
    setRendering(true);
  };

  const fetchProductRecords = async (params) => {
    try {
      const records = await getProductsDataForConfiguration(params);
      setEmptyStateLabel("noData");
      const formattedRecords = records.products.map((product) => {
        return {
          code: product.code,
          created_at: moment(product.created_at).format("DD MMM YYYY"),
          name: product.name,
          grade: product.grade,
          gsm: product.gsm,
          burst_factor: product.burst_factor ? product.burst_factor : "-",
          quality: product.quality ? product.quality : "-",
          bulk: product.bulk,
          price: (currency_List.find((data) => data.code == product.units.price)).symbol + ' ' + parseInt(product.price).toFixed(2) + ' ' + (" /" + weightUnit[product.units.per_weight_unit]?.displayName?.toUpperCase()),
          fastMoving: product.fast_moving_product,
          status: product.status === "active" ? "Active" : "Disabled",
          product_spec: product.product_spec,
          is_stock_available: product.is_stock_available,
          stocks: product.stocks,
          moisture: product.moisture ? product.moisture : "-",
        };
      });
      setProductRecords(formattedRecords);
      setTotalRecords(records.total_products);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log("Error in fetching product records", err);
      setEmptyStateLabel("connectionAPIError");
    }
  };

  const fetchFilteredProducts = () => {

    getFilteredProducts(paginationRef.current, appliedFilters, '', searchValue)
      .then((resp) => {
        setLoading(false);
        setEmptyStateLabel("filter");
        const formattedRecords = resp.data.products.map((product) => {
          return {
            code: product.code,
            created_at: moment(product.created_at).format("DD MMM YYYY"),
            name: product.name,
            grade: product.grade,
            gsm: product.gsm,
            burst_factor: product.burst_factor ? product.burst_factor : "-",
            quality: product.quality,
            bulk: product.bulk,
            price: (currency_List.find((data) => data.code == product.units.price)).symbol + ' ' + parseInt(product.price).toFixed(2) + ' ' + (" /" + weightUnit[product.units.per_weight_unit]?.displayName?.toUpperCase()),
            fastMoving: product.fast_moving_product,
            status: product.status === "active" ? "Active" : "Disabled",
            product_spec: product.product_spec,
            is_stock_available: product.is_stock_available,
            stocks: product.stocks,
            moisture: product.moisture ? product.moisture : "-",
          };
        });
        setProductRecords(formattedRecords);
        setTotalRecords(resp.data.total_products);
      })
      .catch(
        (err) => console.log(err),
        setEmptyStateLabel("connectionAPIError")
      );
  };

  function onChange(pagination, filters, sorter, extra) {
    setProductRecords([]);
    setLoading(true);
    columnsHead.current?.map((item) => {
      if (item.dataIndex !== sorter?.field) {
        item["sortOrder"] = null;
      }
      if (item.dataIndex == sorter?.field) {
        item["sortOrder"] = sorter ? sorter.order : "";
      }
    });
    const tempSort = sorter.order === "ascend" ? "ascending" : "descending";
    if (
      sorter.field &&
      (paginationRef.current.sort_type !== tempSort)
    ) {
      setClearSearch(true);
      setCurrentPage(1);
      setTableParams({
        page: 1,
        size: pagination.pageSize,
        sort_by: sorter.field,
        sort_type: tempSort,
      });
      paginationRef.current = {
        page: 1,
        size: pagination.pageSize,
        sort_by: sorter.field,
        sort_type: tempSort,
      };
    } else {
      setClearSearch(true);
      setCurrentPage(pagination.current);
      setTableParams({
        page: pagination.current,
        size: pagination.pageSize,
        sort_by: sorter.order ? sorter.field : "created_at",
        sort_type: tempSort,
      });
      paginationRef.current = {
        page: pagination.current,
        size: pagination.pageSize,
        sort_by: sorter.order ? sorter.field : "created_at",
        sort_type: tempSort,
      };
    }
  }

  const exportHandler = () => {
    const currentDate = new Date();
    const today =
      currentDate.getDate() +
      "/" +
      currentDate.toLocaleString("default", { month: "long" }) +
      "/" +
      currentDate.getFullYear();
    let fileName = "Product_Records_Kiaznn_" + today;
    if (appliedFilters.length) {
      history("../products-records/export-product", {
        state: {
          body: {
            appliedFilters: appliedFilters,
            page: "product records",
            type: "Filter",
            searchValue: searchValue
          },
          rootPage: "../products-records",
          fileName: fileName,
        },
      });
    } else if (!clearSearch && searchValue) {
      let params = {
        sort_by: "created_at",
        sort_type: "descending",
      };
      history("../products-records/export-product", {
        state: {
          body: {
            searchValue: searchValue,
            params: params,
            page: "product records",
            type: "Search"
          },
          rootPage: "../products-records",
          fileName: fileName,
        },
      });
    } else {
      history("../products-records/export-product", {
        state: {
          body: {
            page: "product records",
            type: "All Data"
          },
          rootPage: "../products-records",
          fileName: fileName,
        },
      });
    }
  };

  const searchProd = async (value = "") => {
    setProductRecords([]);
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
    });
    setLoading(true);
    setSearchValue(value);
    // if (value === "" || value === null) {
    //   setAppliedFilters([]);
    //   setFilterTags([]);
    //   fetchProductRecords(paginationRef.current);
    // } else {
    //   setClearSearch(false);
    //   searchProducts(value, paginationRef.current)
    //     .then((response) => {
    //       setLoading(false);
    //       setEmptyStateLabel("search");
    //       const formattedRecords = response.products?.map((product) => {
    //         return {
    //           code: product.code,
    //           created_at: moment(product.created_at).format("DD MMM YYYY"),
    //           name: product.name,
    //           grade: product.grade,
    //           gsm: product.gsm,
    //           burst_factor: product.burst_factor ? product.burst_factor : "-",
    //           quality: product.quality,
    //           bulk: product.bulk,
    //           price: (currency_List.find((data) => data.code == product.units.price)).symbol + ' ' + parseInt(product.price).toFixed(2) + ' ' + (" /" + weightUnit[product.units.per_weight_unit]?.displayName?.toUpperCase()),
    //           status: product.status === "active" ? "Active" : "Disabled",
    //           product_spec: product.product_spec,
    //           is_stock_available: product.is_stock_available,
    //           stocks: product.stocks,
    //           moisture : product.moisture ? product.moisture : "-",
    //         };
    //       });
    //       setProductRecords(formattedRecords);
    //       setTotalRecords(response.total_products);
    //     })
    //     .catch(
    //       (error) => console.log("Error in searching products:", error),
    //       setEmptyStateLabel("connectionAPIError")
    //     );
    // }
  };

  const routeChange = () => {
    history("./add-new-products");
  };

  const handleAddStock = (record) => {
    setProduct(record);
    setNewStockSizeDrawer(true);
  };
  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 2000);
  };
  const onCloseAddNewStock = () => {
    setNewStockSizeDrawer(false);
  };

  const handleEdit = (record) => {
    history("../edit-products-records", {
      state: { productCode: record.code, action: "edit" },
    });
  };

  const handleView = (record) => {
    history("../edit-products-records", {
      state: {
        productCode: record.code,
        action: "view",
        roles: userDetails.roles.product_records,
      },
    });
  };

  const applyfilter = (filter) => {
    setProductRecords([]);
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
    });
    setCurrentPage(1);

    paginationRef.current = {
      sort_by: "created_at",
      sort_type: "descending",
      page: 1,
      size: 10
    }
    let temp = appliedFilters;
    let alreadySetFilter = false;
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].type === filter.type) {
        temp[i] = filter;
        alreadySetFilter = true;
      }
    }

    const tempVar = alreadySetFilter ? [...temp] : temp.concat(filter);
    setAppliedFilters(tempVar);
    setFilterTags(tempVar.map(formatFilters));
    setTableParams((prevState) => ({
      sort_by: "created_at",
      sort_type: "descending",
      page: 1,
      size: 10
    }));
    setRendering(true);
  };

  const formatFilters = (item) => {
    switch (item.type) {
      case "gsm":
        let gsmOperand = "";
        let gsmValue = "";
        if (item.operator === "in_range") {
          gsmOperand = "between";
          gsmValue = `${item.min_gsm} and ${item.max_gsm}`;
        } else if (item.operator === "equal_to") {
          gsmOperand = "equals";
          gsmValue = `${item.gsm}`;
        } else if (item.operator === "less_than") {
          gsmOperand = "less than";
          gsmValue = `${item.gsm}`;
        } else {
          gsmOperand = "greater than";
          gsmValue = `${item.gsm}`;
        }
        return {
          type: item.type,
          formattedType: "GSM",
          operand: gsmOperand,
          value: gsmValue,
        };
      case "grade_quality":
        const value =
          item.grades.length > 1
            ? `${item.grades[0].grade}(${item.grades[0].qualities.join()}) or ${item.grades.length - 1
            } others`
            : `${item.grades[0].grade}` + (item.grades[0].qualities?.length ? `"(${item.grades[0].qualities.join()})"` : ``);
        return { type: item.type, formattedType: "Grade", operand: "-", value };
      case "created_date":
        let dateOperand = "";
        let dateValue = "";
        if (item.start_date === item.end_date) {
          dateOperand = "-";
          dateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          dateOperand = "between";
          dateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Created date",
          operand: dateOperand,
          value: dateValue,
        };
      case "burst_factor":
        let burstOperand = "";
        let burstValue = "";
        if (item.operator === "in_range") {
          burstOperand = "between";
          burstValue = `${item.min_burst_factor} and ${item.max_burst_factor}`;
        } else if (item.operator === "equal_to") {
          burstOperand = "equals";
          burstValue = `${item.burst_factor}`;
        } else if (item.operator === "less_than") {
          burstOperand = "less than";
          burstValue = `${item.burst_factor}`;
        } else {
          burstOperand = "greater than";
          burstValue = `${item.burst_factor}`;
        }
        return {
          type: item.type,
          formattedType: "Burst Factor",
          operand: burstOperand,
          value: burstValue,
        };
      case "bulk":
        let bulkOperand = "";
        let bulkValue = "";
        if (item.operator === "in_range") {
          bulkOperand = "between";
          bulkValue = `${item.min_bulk} and ${item.max_bulk}`;
        } else if (item.operator === "equal_to") {
          bulkOperand = "equals";
          bulkValue = `${item.bulk}`;
        } else if (item.operator === "less_than") {
          bulkOperand = "less than";
          bulkValue = `${item.bulk}`;
        } else {
          bulkOperand = "greater than";
          bulkValue = `${item.bulk}`;
        }
        return {
          type: item.type,
          formattedType: "Bulk",
          operand: bulkOperand,
          value: bulkValue,
        };
      case "price":
        let priceOperand = "";
        let priceValue = "";
        if (item.operator === "in_range") {
          priceOperand = "between";
          priceValue = `${item.min_price} and ${item.max_price}`;
        } else if (item.operator === "equal_to") {
          priceOperand = "equals";
          priceValue = `${item.price}`;
        } else if (item.operator === "less_than") {
          priceOperand = "less than";
          priceValue = `${item.price}`;
        } else {
          priceOperand = "greater than";
          priceValue = `${item.price}`;
        }
        return {
          type: item.type,
          formattedType: "Price",
          operand: priceOperand,
          value: priceValue,
        };
      case "status":
        const formattedStatus =
          item.status === "both"
            ? `Active/Disabled`
            : item.status === "active"
              ? `Active`
              : `Disabled`;
        return {
          type: item.type,
          formattedType: "Status",
          operand: "-",
          value: formattedStatus,
        };
    }
  };

  const removeFilter = (filter) => {
    setProductRecords([]);
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
    });
    const filterList = appliedFilters.filter((item) => {
      return item.type !== filter.type;
    });
    const formattedFilterList = filterTags.filter((item) => {
      return item.type !== filter.type;
    });
    setFilterTags(formattedFilterList);
    setAppliedFilters(filterList);
    // setSearchValue("");
    // setClearSearch(true);
    setLoading(true);
    setRendering(true);
    setCurrentPage(1);
    setTableParams((prevState) => ({
      sort_by: "created_at",
      sort_type: "descending",
      page: 1,
      size: 10
    }));
    paginationRef.current = {
      sort_by: "created_at",
      sort_type: "descending",
      page: 1,
      size: 10
    }
  };
  const onUploadProduct = () => {
    history("./upload-products");
  };
  return (
    <RightLayoutContainer id="right-layout-container">
      <style dangerouslySetInnerHTML={{
        __html: `
        .ant-tabs, .ant-tabs-content-holder, .ant-tabs-content, .ant-tabs-tabpane {
          overflow: visible !important;
        }
        .ant-table-sticky-holder {
          z-index: 101 !important;
        }
        .tableDataFormat table colgroup col {
          min-width: 100px !important;
        }
        .tableDataFormat table colgroup col:first-child {
          min-width: 160px !important;
        }
        .tableDataFormat table colgroup col:nth-child(2) {
          min-width: 140px !important;
        }
      `}} />
      <PageTitleComp ref={titleRef} style={{ borderBottom: "0", position: "sticky", top: stickyOffsets.title, zIndex: 100, backgroundColor: "#fff", paddingBottom: "10px" }}>
        <PageHeader
          ghost={false}
          title="Product Records"
          extra={
            userDetails.roles.product_records.edit && [
              <Button
                key="1"
                className="themeBtn noBg"
                // disabled={!roles.edit_own}
                onClick={onUploadProduct}
              >
                <Iconmoon icon="import" size={14} color="#EA655B" />
                Upload Products
              </Button>,
              <Button key="2" className="themeBtn" onClick={routeChange}>
                <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                Add a new product
              </Button>,
            ]
          }
        ></PageHeader>
      </PageTitleComp>
      <TableLayoutData>
        <div className="tableDataFormat">
          <SearchContainer
            placeholder={"Search product code or product name"}
            fetchOrder={searchProd}
            exportRole={productRecords?.length ? true : false}
            exportTrigger={exportHandler}
            clearSearch={clearSearch}
            setClearSearch={setClearSearch}
            searchedValue={searchValue}
            filterOptions={[
              {
                key: 0,
                label: "Filter By GSM",
                value: "gsm",
                type: "inputSelect",
              },
              {
                key: 1,
                label: "Filter by Grade/Quality",
                value: "grade_quality",
                type: "grade",
              },
              {
                key: 2,
                label: "Filter By Burst Factor",
                value: "burst_factor",
                type: "inputSelect",
              },
              {
                key: 3,
                label: "Filter by Bulk",
                value: "bulk",
                type: "inputSelect",
              },
              {
                key: 4,
                label: "Filter by Price",
                value: "price",
                type: "inputSelect",
                unitType: "price"
              },
              {
                key: 5,
                label: "Filter by Created date",
                value: "created_date",
                type: "date",
              },
              {
                key: 6,
                label: "Filter by Status",
                value: "status",
                type: "multiSelect",
              },
            ]}
            applyFilter={applyfilter}
          />
          {filterTags.map((filter) => (
            <span className="filter-tags">
              <Iconmoon icon="filter" size={13} color="#a8a8a8" />
              &nbsp;
              <span>{filter.formattedType}</span>
              &nbsp;
              <span>{filter.operand}</span>
              &nbsp;
              <span>{filter.value}</span>
              <span>
                {" "}
                <button
                  onClick={() => {
                    removeFilter(filter);
                  }}
                >
                  {" "}
                  <Iconmoon icon="wrong" size={15} color="#a8a8a8" />{" "}
                </button>
              </span>
            </span>
          ))}
          {loading ? (
            <TableShimmer
              header={columnsHead.current}
              scroll={{ x: 1700 }}
            />
          ) : productRecords?.length ? (
            <Table
              columns={columnsHead.current}
              dataSource={productRecords}
              onChange={onChange}
              pagination={{
                current: currentPage,
                total: totalRecords,
                showTitle: false,
                showSizeChanger: true,
                pageSize: paginationRef.current.size,
                showTotal: (total, range) =>
                  `Showing ${range[0]}-${range[1]} of ${total} results`,
              }}
              scroll={{ x: "max-content" }}
              sticky={{
                offsetHeader: stickyOffsets.table,
                getContainer: () => {
                  let node = document.getElementById('right-layout-container');
                  while (node && node !== document.body) {
                    const style = window.getComputedStyle(node);
                    if (style.overflowY === 'auto' || style.overflowY === 'scroll') return node;
                    node = node.parentNode;
                  }
                  return window;
                }
              }}
            />
          ) : (
            <EmptyState
              img={
                emptyStateLabel === "noData" || emptyStateLabel === "filter"
                  ? emptyState_NoData
                  : emptyStateLabel === "search"
                    ? emptyState_Search
                    : emptyState_ConnectionAPIError
              }
              heading={emptyStatePropsData.heading}
              subHeading={emptyStatePropsData.subHeading}
              label={emptyStatePropsData.label}
              refresh={refresh}
            />
          )}
        </div>
      </TableLayoutData>

      {(addToaster && location?.state?.response) && (
        <AlertContainer
          closeIcon={true}
          setClose={setAddToaster}
          color={`${location?.state.response.error ? "red" : "green"} toaster`}
          icon={location.state.response.error ? alertRed : alertGreen}
          msg={
            location.state.response.error
              ? location.state.response.msg
              : // : `A new product is successfully added`
              `A new product ${location.state.response.data.name} is successfully added`
          }
        >
          {/* {console.log(location.state.response)} */}
          {setTimeout(() => setAddToaster(false), 3000)}
        </AlertContainer>
      )}

      {(deleteToaster && location?.state?.response) && (
        <AlertContainer
          closeIcon={true}
          setClose={setDeleteToaster}
          color={`${location.state.response.error ? "red" : "green"} toaster`}
          icon={location.state.response.error ? alertRed : alertGreen}
          msg={
            location.state.response.error
              ? location.state.response.msg
              : `Product is successfully deleted`
          }
        >
          {setTimeout(() => setDeleteToaster(false), 3000)}
        </AlertContainer>
      )}

      {visibleToaster && !actionToaster.error && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg={actionToaster.msg}
        />
      )}
      {visibleToaster && actionToaster.error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={actionToaster.msg}
        />
      )}

      {newStockSizeDrawer && (
        <AddNewSize
          visible={newStockSizeDrawer}
          onClose={onCloseAddNewStock}
          productCode={product.code}
          productSpec={product.product_spec}
          rendering={setRendering}
          isAddNewStockClicked={true}
          isViewStockClicked={false}
          isEditStockClicked={false}
          selectedStockSizeRow={selectedStockSizeRow}
          selectedStockSize={
            stockSizesListRawData.filter(
              (stockSize) => stockSize.width == selectedStockSize
            )[0]
          }
          toasterAction={setActionToaster}
          showToaster={showToaster}
        ></AddNewSize>
      )}
    </RightLayoutContainer>
  );
};

export default ProductsRecordsData;
